import { Observable } from 'rxjs';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { ExperiencesService } from '@ordersnproducts/modules/shared/services/experiences.service';
import { takeUntil } from 'rxjs/operators';
import { map } from 'rxjs/operators';
export namespace contractVisibleFieldProvider {
  export class Visible extends BaseAsyncValue<boolean> {
    getValue(): Observable<any> {
      const experiencesService: ExperiencesService = this.injector.get(ExperiencesService);
      const featureToggle: FeatureToggleService = this.injector.get(FeatureToggleService);
      const toggle = featureToggle.isFeatureEnabled(Features.RemoveContractFieldEnabled);
      return experiencesService.commandDcoEnabled$().pipe(
        takeUntil(this.ngDestroy),
        map((isCommand2) => {
          if (toggle && (isCommand2 || experiencesService.isArkikUlEnabled())) {
            return false;
          }
          return true;
        }),
      );
    }
  }

  export class Hidden extends BaseAsyncValue<boolean> {
    getValue(): Observable<any> {
      const experiencesService: ExperiencesService = this.injector.get(ExperiencesService);
      const featureToggle: FeatureToggleService = this.injector.get(FeatureToggleService);
      const toggle = featureToggle.isFeatureEnabled(Features.RemoveContractFieldEnabled);
      return experiencesService.commandDcoEnabled$().pipe(
        takeUntil(this.ngDestroy),
        map((isCommand2) => {
          if (toggle && (isCommand2 || experiencesService.isArkikUlEnabled())) {
            return true;
          }
          return false;
        }),
      );
    }
  }
}
